
"use strict";

var truncate = Math.floor
  , numpatt = '\\d+(?:[\\.,]\\d+)?'
  , iso8601DurationRe = new RegExp('^P' + 
              '(?:' + 
                '(' + numpatt + 'W)' +
                '|' +
                '(' + numpatt + 'Y)?(' + numpatt + 'M)?(' + numpatt + 'D)?' + 
                '(?:T' + 
                  '(' + numpatt + 'H)?(' + numpatt + 'M)?(' + numpatt + 'S)?' +
                ')?' +
              ')$')
  , durationParts = ['weeks', 'years', 'months', 'days', 'hours', 'minutes', 'seconds']
  , iso8601CombinedRe = /^P(\d\d\d\d)-?(\d\d)-?(\d\d)(?:T(\d\d):?(\d\d):?(\d\d(?:\.\d+)?))?$/;

/*
  a `duration` may be:

   - undefined
   - a Duration instance (passed or cloned)
   - iso8601 period string
   - number of milliseconds

   constructor form will always return a new object
*/
function Duration(duration) {
  var value;

  if (!(this instanceof Duration)) {
    if (duration instanceof Duration) return duration;
    return new Duration(duration);
  }

  if (duration === undefined) return;

  if (duration instanceof Duration) {
    value = duration.years;
    if (value !== undefined) this.years = value;
    value = duration.weeks;
    if (value !== undefined) this.weeks = value;
    value = duration.months;
    if (value !== undefined) this.months = value;
    value = duration.days;
    if (value !== undefined) this.days = value;
    value = duration.hours;
    if (value !== undefined) this.hours = value;
    value = duration.minutes;
    if (value !== undefined) this.minutes = value;
    value = duration.seconds;
    if (value !== undefined) this.seconds = value;
  }
  else if ('number' === typeof duration) {
    if (!isFinite(duration)) {
      throw new TypeError('duration given as a number of milliseconds must be finite');
    }
    convertMilliseconds(this, duration);
  }
  else {
    if ('string' !== typeof duration || duration[0] !== 'P') {
      throw new TypeError('duration given must be a string and start with a "P"');
    }
    parseDuration(this, duration);
    this.source = duration;
  }
}

Duration.prototype.toJSON = function() {
  return this.toString();
};

Duration.prototype.toString = function(force) {
  var value = this.source;
  if (value !== undefined && !force) return value;

  var timestr = 'T', result = 'P';

  value = this.years;
  if (value !== undefined) result += value + 'Y';
  value = this.weeks;
  if (value !== undefined) result += value + 'W';
  value = this.months;
  if (value !== undefined) result += value + 'M';
  value = this.days;
  if (value !== undefined) result += value + 'D';

  value = this.hours;
  if (value !== undefined) timestr += value + 'H';
  value = this.minutes;
  if (value !== undefined) timestr += value + 'M';
  value = this.seconds;
  if (value !== undefined) timestr += value + 'S';

  if (timestr.length !== 1) result += timestr;

  this.source || (this.source = result);

  return result;
};

Duration.prototype.addToDate = function(date) {
  var value, mday, rest;

  value = this.weeks || 0;
  /* adjust weeks */
  if (value !== 0) {
    value *= 7;
    date.setDate(date.getDate() + truncate(value));
    rest = value % 1;
  }
  else {
    /* adjust years */
    value = this.years || 0;
    if (value !== 0) {
      date.setFullYear(date.getFullYear() + truncate(value));
      rest = value % 1 * 12;
    }
    else rest = 0;
    /* adjust months */
    value = (this.months || 0) + rest;
    if (value !== 0) {
      rest = value % 1;
      value = date.getMonth() + truncate(value);
      if (rest !== 0) {
        /* determine part of the target month in days */
        mday = date.getDate();
        date.setMonth(value + 1, 0);
        /* multiply by the last day of the current month */
        rest *= date.getDate();
        date.setMonth(value, mday);
      }
      else date.setMonth(value);
    }
  }
  /* adjust days */
  value = (this.days || 0) + rest;
  if (value !== 0) {
    date.setDate(date.getDate() + truncate(value));
    rest = value % 1 * 24;
  }
  /* adjust hours */
  value = (this.hours || 0) + rest;
  if (value !== 0) {
    date.setHours(date.getHours() + truncate(value));
    rest = value % 1 * 60;
  }
  /* adjust minutes */
  value = (this.minutes || 0) + rest;
  if (value !== 0) {
    date.setMinutes(date.getMinutes() + truncate(value));
    rest = value % 1 * 60;
  }
  /* adjust seconds */
  value = (this.seconds || 0) + rest;
  if (value !== 0) {
    date.setMilliseconds(date.getMilliseconds() + truncate(value * 1000));
  }

  return date;
};

Duration.prototype.subtractFromDate = function(date) {
  var value, mday, rest;

  value = this.weeks || 0;
  /* adjust weeks */
  if (value !== 0) {
    value *= 7;
    date.setDate(date.getDate() - truncate(value));
    rest = value % 1;
  }
  else {
    /* adjust years */
    value = this.years || 0;
    if (value !== 0) {
      date.setFullYear(date.getFullYear() - truncate(value));
      rest = value % 1 * 12;
    }
    else rest = 0;
    /* adjust months */
    value = (this.months || 0) + rest;
    if (value !== 0) {
      rest = value % 1;
      value = date.getMonth() - truncate(value);
      if (rest !== 0) {
        /* determine part of the previous month in days */
        mday = date.getDate();
        date.setMonth(value, 0);
        /* multiply by the last day of the current month */
        rest *= date.getDate();
        date.setMonth(value, mday);
      }
      else date.setMonth(value);
    }
  }
  /* adjust days */
  value = (this.days || 0) + rest;
  if (value !== 0) {
    date.setDate(date.getDate() - truncate(value));
    rest = value % 1 * 24;
  }
  /* adjust hours */
  value = (this.hours || 0) + rest;
  if (value !== 0) {
    date.setHours(date.getHours() - truncate(value));
    rest = value % 1 * 60;
  }
  /* adjust minutes */
  value = (this.minutes || 0) + rest;
  if (value !== 0) {
    date.setMinutes(date.getMinutes() - truncate(value));
    rest = value % 1 * 60;
  }
  /* adjust seconds */
  value = (this.seconds || 0) + rest;
  if (value !== 0) {
    date.setMilliseconds(date.getMilliseconds() - truncate(value * 1000));
  }

  return date;
};

Duration.prototype.addToUTCDate = function(date) {
  var value, mday, rest;

  value = this.weeks || 0;
  /* adjust weeks */
  if (value !== 0) {
    value *= 7;
    date.setUTCDate(date.getUTCDate() + truncate(value));
    rest = value % 1;
  }
  else {
    /* adjust years */
    value = this.years || 0;
    if (value !== 0) {
      date.setUTCFullYear(date.getUTCFullYear() + truncate(value));
      rest = value % 1 * 12;
    }
    else rest = 0;
    /* adjust months */
    value = (this.months || 0) + rest;
    if (value !== 0) {
      rest = value % 1;
      value = date.getUTCMonth() + truncate(value);
      if (rest !== 0) {
        /* determine part of the target month in days */
        mday = date.getUTCDate();
        date.setUTCMonth(value + 1, 0);
        /* multiply by the last day of the current month */
        rest *= date.getUTCDate();
        date.setUTCMonth(value, mday);
      }
      else date.setUTCMonth(value);
    }
  }
  /* adjust days */
  value = (this.days || 0) + rest;
  if (value !== 0) {
    date.setUTCDate(date.getUTCDate() + truncate(value));
    rest = value % 1 * 24;
  }
  /* adjust hours */
  value = (this.hours || 0) + rest;
  if (value !== 0) {
    date.setUTCHours(date.getUTCHours() + truncate(value));
    rest = value % 1 * 60;
  }
  /* adjust minutes */
  value = (this.minutes || 0) + rest;
  if (value !== 0) {
    date.setUTCMinutes(date.getUTCMinutes() + truncate(value));
    rest = value % 1 * 60;
  }
  /* adjust seconds */
  value = (this.seconds || 0) + rest;
  if (value !== 0) {
    date.setUTCMilliseconds(date.getUTCMilliseconds() + truncate(value * 1000));
  }

  return date;
};

Duration.prototype.subtractFromUTCDate = function(date) {
  var value, mday, rest;

  value = this.weeks || 0;
  /* adjust weeks */
  if (value !== 0) {
    value *= 7;
    date.setUTCDate(date.getUTCDate() - truncate(value));
    rest = value % 1;
  }
  else {
    /* adjust years */
    value = this.years || 0;
    if (value !== 0) {
      date.setUTCFullYear(date.getUTCFullYear() - truncate(value));
      rest = value % 1 * 12;
    }
    else rest = 0;
    /* adjust months */
    value = (this.months || 0) + rest;
    if (value !== 0) {
      rest = value % 1;
      value = date.getUTCMonth() - truncate(value);
      if (rest !== 0) {
        /* determine part of the previous month in days */
        mday = date.getUTCDate();
        date.setUTCMonth(value, 0);
        /* multiply by the last day of the current month */
        rest *= date.getDate();
        date.setUTCMonth(value, mday);
      }
      else date.setUTCMonth(value);
    }
  }
  /* adjust days */
  value = (this.days || 0) + rest;
  if (value !== 0) {
    date.setUTCDate(date.getUTCDate() - truncate(value));
    rest = value % 1 * 24;
  }
  /* adjust hours */
  value = (this.hours || 0) + rest;
  if (value !== 0) {
    date.setUTCHours(date.getUTCHours() - truncate(value));
    rest = value % 1 * 60;
  }
  /* adjust minutes */
  value = (this.minutes || 0) + rest;
  if (value !== 0) {
    date.setUTCMinutes(date.getUTCMinutes() - truncate(value));
    rest = value % 1 * 60;
  }
  /* adjust seconds */
  value = (this.seconds || 0) + rest;
  if (value !== 0) {
    date.setUTCMilliseconds(date.getUTCMilliseconds() - truncate(value * 1000));
  }

  return date;
};

Duration.prototype.toSeconds = function(refdate) {
  return this.toMilliseconds(refdate) / 1000;
};

Duration.prototype.toMilliseconds = function(refdate) {
  var timestamp = ('number' === typeof refdate) ? refdate
                                                : (refdate != null ? refdate.getTime()
                                                                   : Date.now())
    , date = new Date(timestamp);

  this.addToDate(date);
  return date.getTime() - timestamp;
};

Duration.prototype.toUTCSeconds = function(refdate) {
  return this.toUTCMilliseconds(refdate) / 1000;
};

Duration.prototype.toUTCMilliseconds = function(refdate) {
  var timestamp = ('number' === typeof refdate) ? refdate
                                                : (refdate != null ? refdate.getTime()
                                                                   : Date.now())
    , date = new Date(timestamp);

  this.addToUTCDate(date);
  return date.getTime() - timestamp;
};

function convertMilliseconds(duration, value) {
  if (value < 0) {
    value = -value;
  }

  duration.seconds = value / 1000;
}

/*
 parses PnW or PnYnMnDTnHnMnS or PYYYYMMDDThhmmss or P[YYYY]-[MM]-[DD]T[hh]:[mm]:[ss]
*/
function parseDuration(duration, value) {
  var deltapart = -1
    , result = value.match(iso8601DurationRe);

  if (result === null) {
    result = value.match(iso8601CombinedRe);
    if (result === null) throw new TypeError('Invalid ISO8601 duration format: "' + value + '"');
    deltapart = 0;
  }

  for(var i = 1, len = result.length; i < len; ++i) {
    value = result[i];
    if (value !== undefined) {
      value = parseFloat(value);
      if (value) duration[durationParts[deltapart + i]] = value;
    }
  }

}

module.exports = Duration;
